<template>
	<span>
		<v-container fluid fill-height class="home-hero" style="max-height: 50vh;">
			<v-row align-center justify-center fill-height>
				<v-col class="font-weight-white text-center white--text headline">
					<h1 >با ما در تماس باشید</h1>
				</v-col>
			</v-row>
		</v-container>
	</span>
</template>

<script>
	export default {
		name: "HomeHero",
	};
</script>

<style scoped>
	.home-hero {
		background: url("~@/assets/img/contactus-hero.jpg");
		background-size: cover;
		width: 100%;
		height: 100%;
	}
	.fade-enter,
	.fade-appear {
		opacity: 1;
	}
	.fade-enter-to,
	.fade.appear-to {
		opacity: 0;
	}
	.fade-enter-active,
	.fade-appear-active {
		transition: opacity 3s ease;
	}
</style>
